import React from 'react';
export function FlagIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.118 8L18.9 4.447A1 1 0 0018 3H7a1 1 0 00-2 0v18a1 1 0 102 0v-8h11a1 1 0 00.895-1.447L17.118 8zm-2.013.447L16.382 11H7V5h9.382l-1.277 2.553a1 1 0 000 .894z"
  }));
}